import(/* webpackMode: "eager" */ "/root/tekyerde-frontend/app/(commerce)/kanvas/page.tsx");
